import TimeoutError from 'utils/retry/TimeoutError';

import { timeUtils, Duration } from '@instinet-analytics/core-lib';

const { advanceTime } = timeUtils;

export async function scheduleTimeout(timeout: Duration): Promise<void> {
    await advanceTime(timeout);
    throw new TimeoutError();
}
